import BaseModelFactory from './base.factory'
import PromotionCodeRedemptionService from './../services/PromotionCodeRedemption.service'
import PromotionCodeRedemption from './../models/promotion-code-redemption.model'

class PromotionCodeRedemptionFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: PromotionCodeRedemptionService, Model: PromotionCodeRedemption }
    )
  static findById = async id =>
    await this._findBy({ id: id }, { Service: PromotionCodeRedemptionService, Model: PromotionCodeRedemption })
  static findAllByUserId = async id =>
    await this._findAllBy({ user_id: id }, { Service: PromotionCodeRedemptionService, Model: PromotionCodeRedemption })
  static create = payload =>
    this._create(payload, {
      Service: PromotionCodeRedemptionService,
      Model: PromotionCodeRedemption,
    })
}

export default PromotionCodeRedemptionFactory
